var React = require('react');

function Shop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.9849 3.75631C4.99259 2.33779 6.11566 1.18871 7.49259 1.18871C8.91566 1.18078 10.0157 2.33779 10.0157 3.77216V3.96236H11.1695V3.77216C11.1695 1.68796 9.52336 0 7.50797 0H7.49259C5.4849 0 3.83875 1.68004 3.83105 3.77216V3.96236H4.9849V3.75631Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1692 3.9624V6.91832H10.0154V3.9624H4.98462L4.98462 6.91832H3.83077L3.83078 3.9624H0V8.27345C0 12.5369 3.36154 16 7.5 16C11.6385 16 15 12.5369 15 8.27345V3.9624H11.1692Z","fill":"white","key":1})]);
}

Shop.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none"};

module.exports = Shop;

Shop.default = Shop;
